'use client';

import { useEffect, useRef } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function CtaSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-el').forEach((el, i) => {
              setTimeout(() => el.classList.add('revealed'), i * 120);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-28 px-6 border-t border-white/[0.05]" ref={sectionRef}>
      <div className="max-w-4xl mx-auto text-center">
        {/* Scarcity badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-gold/30 bg-gold/5 text-xs font-bold tracking-widest text-gold uppercase mb-10 reveal-el">
          <span className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse" />
          Places limitées — Session Q1 2026
        </div>

        <h2 className="font-fraunces text-5xl md:text-6xl lg:text-7xl font-light italic leading-tight text-cream mb-6 reveal-el">
          Rejoignez le Programme<br />
          <span className="text-moss-light">Partenaire GiteZen</span>
        </h2>

        <p className="text-cream/60 text-lg leading-relaxed max-w-2xl mx-auto mb-12 reveal-el">
          Structurez votre gestion multi-biens dès aujourd'hui. Candidatez en 5 minutes, recevez une réponse sous 48h, et démarrez votre onboarding personnalisé dès la semaine suivante.
        </p>

        {/* CTA button */}
        <div className="reveal-el mb-10">
          <a
            href="/candidature"
            className="group inline-flex items-center gap-3 bg-moss text-cream px-12 py-5 rounded-full text-lg font-bold hover:bg-moss-light transition-all duration-300 shadow-2xl shadow-moss/30"
          >
            Candidater au Programme
            <Icon name="ArrowRightIcon" size={20} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </div>

        {/* Link to main website */}
        <div className="reveal-el mb-10">
          <a
            href="https://gitezen.pro"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-cream/50 hover:text-moss-light transition-colors text-sm font-medium"
          >
            <Icon name="ArrowTopRightOnSquareIcon" size={16} />
            Découvrir GiteZen.pro
          </a>
        </div>

        {/* Value props row */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-xs text-cream/40 font-medium tracking-wide reveal-el">
          {[
            '3 mois premium offerts',
            'Valeur 500€+',
            'Sans engagement',
            'Réponse 48h',
            'Places limitées',
          ]?.map((item, i) => (
            <span key={i} className="flex items-center gap-1.5">
              <Icon name="CheckCircleIcon" size={13} className="text-moss-light" variant="solid" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}